import React from "react";
import {
  TextInput,
  LongTextInput,
  email,
  required,
  ImageField,
  EditButton,
  RefreshButton,
  ListButton,
} from "admin-on-rest";
// SelectInput,
import { CardActions } from "material-ui/Card";
import RaisedButton from "material-ui/RaisedButton";
import CheckboxGroupInput from "../components/form/CheckboxGroupInput";
// import IconTitle from "../components/icon_title";
import MarketerForm from "./MarketerForm";
// import MarketerShowLayout from "./MarketerShowLayout";
import ImageOlaSingleInput from "../components/image";
import DependentImageInput from "../components/image/DependentImageInput";
import { dataCategory, marketerDefaultValue } from "./utilsMarketer";
import { styles } from "./styles";
import MarketerCustomShow from "./MarketerCustomShow";
import PartnerCodeField from "./form/PartnerCodeField";
//dataStatusMarketer,
// import { EditMarketersForm } from "./form/EditMarketersForm";

const optionsStyle = {
  labelStyle: { width: 180 },
  style: {
    display: "flex",
    flex: "1 1 30%",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};

export const MarketersForm = (props) => {
  const { listMarketer, ...rest } = props;
  return (
    <MarketerForm {...rest} defaultValue={marketerDefaultValue}>
      <TextInput
        label="resources.marketers.fields.first_name"
        source="first_name"
        validate={[required]}
      />
      <TextInput
        label="resources.marketers.fields.last_name"
        source="last_name"
        validate={[required]}
      />
      <TextInput
        label="resources.marketers.fields.nickname"
        source="nickname"
        validate={[required]}
      />

      <PartnerCodeField
        {...props}
        label={"resources.marketers.fields.partner_id"}
        optionText="nickname"
        source={"partner_id"}
        optionValue="id"
      />
      <TextInput
        label="resources.marketers.fields.google_email"
        source="email"
        validate={[required, email]}
      />
      <TextInput
        label="resources.marketers.fields.mobile"
        source="mobile"
        validate={[required]}
      />
      <DependentImageInput
        label="resources.marketers.fields.avatar"
        dependsOn={"nickname"}
        {...props}
      >
        <ImageOlaSingleInput
          source="avatarUrl"
          toValue={props.toValue}
          labelImage="Avatar"
          label={"resources.marketers.fields.avatar"}
          accept="image/*"
        >
          <ImageField source="src" title="title" />
        </ImageOlaSingleInput>
      </DependentImageInput>
      <TextInput label="resources.marketers.banks.bank" source="custom1.bank" />
      <TextInput
        label="resources.marketers.fields.profile"
        source="social.profile"
      />
      <LongTextInput
        label="resources.marketers.banks.full_name"
        source="custom1.full_name"
      />
      <TextInput
        label="resources.marketers.banks.bank_account"
        source="custom1.account"
      />
      <LongTextInput
        label="resources.marketers.banks.bank_branch"
        source="custom1.bank_branch"
      />
      <TextInput
        label="resources.marketers.social.instagram"
        source="social.instagram.id"
      />
      <TextInput
        label="resources.marketers.social.facebook"
        source="social.facebook.id"
      />
      <TextInput
        label="resources.marketers.social.twitter"
        source="social.twitter.id"
      />
      <TextInput
        label="resources.marketers.social.youtube"
        source="social.youtube.id"
      />
      <CheckboxGroupInput
        label=""
        source="custom3"
        choices={dataCategory}
        options={optionsStyle}
      />
    </MarketerForm>
  );
};
// const MarketersEditForm = props => {
//   return (
//     <MarketerForm {...props} defaultValue={marketerDefaultValue}>
//       <TextInput
//         label="resources.marketers.fields.first_name"
//         source="first_name"
//       />
//       <TextInput
//         label="resources.marketers.fields.last_name"
//         source="last_name"
//       />
//       <TextInput
//         label="resources.marketers.fields.nickname"
//         source="nickname"
//       />
//       <SelectInput
//         label="resources.marketers.fields.status"
//         source="status"
//         choices={dataStatusMarketer}
//       />
//       <TextInput
//         label="resources.marketers.fields.google_email"
//         source="email"
//         validate={[required, email]}
//       />
//       <TextInput label="resources.marketers.fields.mobile" source="mobile" />
//       <TextInput
//         label="resources.marketers.fields.profile"
//         source="social.profile"
//       />
//       <DependentImageInput
//         label="resources.marketers.fields.avatar"
//         dependsOn={"nickname"}
//         {...props}
//       >
//         <ImageOlaSingleInput
//           source="avatarUrl"
//           toValue={props.toValue}
//           labelImage="Avatar"
//           label={"resources.marketers.fields.avatar"}
//           accept="image/*"
//         >
//           <ImageField source="src" title="title" />
//         </ImageOlaSingleInput>
//       </DependentImageInput>

//       {props.permissions === "Admin" ? (
//         <TextInput
//           label="resources.marketers.banks.bank"
//           source="custom1.bank"
//         />
//       ) : (
//         <TextField
//           label="resources.marketers.banks.bank"
//           source="custom1.bank"
//         />
//       )}
//       {props.permissions === "Admin" ? (
//         <LongTextInput
//           label="resources.marketers.banks.full_name"
//           source="custom1.full_name"
//         />
//       ) : (
//         <TextField
//           label="resources.marketers.banks.full_name"
//           source="custom1.full_name"
//         />
//       )}
//       {props.permissions === "Admin" ? (
//         <TextInput
//           label="resources.marketers.banks.bank_account"
//           source="custom1.account"
//         />
//       ) : (
//         <TextField
//           label="resources.marketers.banks.bank_account"
//           source="custom1.account"
//         />
//       )}
//       {props.permissions === "Admin" ? (
//         <LongTextInput
//           label="resources.marketers.banks.bank_branch"
//           source="custom1.bank_branch"
//         />
//       ) : (
//         <TextField
//           label="resources.marketers.banks.bank_branch"
//           source="custom1.bank_branch"
//         />
//       )}

//       <TextInput
//         label="resources.marketers.social.instagram"
//         source="social.instagram.id"
//       />
//       <TextInput
//         label="resources.marketers.social.facebook"
//         source="social.facebook.id"
//       />
//       <TextInput
//         label="resources.marketers.social.twitter"
//         source="social.twitter.id"
//       />
//       <TextInput
//         label="resources.marketers.social.youtube"
//         source="social.youtube.id"
//       />
//       {/* <TextInput label="resources.marketers.social.followers" source="social.instagram.followers"/>
//     <TextInput label="resources.marketers.social.followers" source="social.facebook.followers"/>
//     <TextInput label="resources.marketers.social.followers" source="social.twitter.followers"/>
//     <TextInput label="resources.marketers.social.followers" source="social.youtube.followers" /> */}
//       <CheckboxGroupInput
//         label=""
//         source="custom3"
//         choices={dataCategory}
//         options={optionsStyle}
//       />
//     </MarketerForm>
//   );
// };

// export const MarketerCreate = (props) => {
//   <Create
//     {...props}
//     title={<IconTitle icon="marketers" title={"resources.marketers.title"} />}
//   >
//     <MarketersForm {...props} redirect="show" />
//   </Create>;
// };

// export const MarketerEdit = (props) => (
//   <Edit
//     {...props}
//     title={<IconTitle icon="marketers" title={"resources.marketers.title"} />}
//   >
//     {(permissions) => (
//       // <MarketersEditForm {...props} redirect="show" permissions={permissions} />
//       <EditMarketersForm {...props} redirect="show" permissions={permissions} />
//     )}
//   </Edit>
// );

export const FullNameField = ({ record = {} }) => (
  <span>
    {record.first_name} {record.last_name}
  </span>
);
FullNameField.defaultProps = { label: "Name" };

export const BankField = ({ record = {} }) => (
  <span>
    {record.bank} {record.bank_account}
  </span>
);
BankField.defaultProps = { label: "Bank" };

export const MarketerShowActions = ({
  basePath,
  data,
  onShowDialog,
  isShowAdjust,
}) => (
  <CardActions
    style={styles.cardActionStyleSmall}
    className="marketers-actions"
  >
    {isShowAdjust === 1 && (
      <RaisedButton
        primary
        label={"Adjust Commission"}
        onClick={onShowDialog}
      />
    )}
    <EditButton basePath={basePath} record={data} />
    <ListButton basePath={basePath} />
    <RefreshButton />
    {/* Add your custom actions */}
  </CardActions>
);

export const MarketerShow = (props) => <MarketerCustomShow {...props} />;



// WEBPACK FOOTER //
// ./src/marketers/Create.js